module.exports = __webpack_public_path__ + "static/img/手术宣教@3x.83825dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/手术宣教@3x.png
// module id = 314
// module chunks = 379 380